
<template>
    <div class="dialog">
        <van-overlay :show="show"  :z-index="2100">
            <div class="dialog-wrapper" @click.stop>
                <div class="dialog-content">
                    请使用微信扫描下方二维码支付
                </div>
                <countdown ref="countdown" :totalSeconds="120" @end="end"/>
                <vue-qrcode :value="content" :options="{ width: 260 }"></vue-qrcode>
                <div class="dialog-wrapper-btn flex justify-between">
                    <van-button
                        class="dialog-wrapper-btn-item"
                        @click="hideDialog"
                        plain
                        color="#009AF3"
                        >{{ leftBtnText }}</van-button
                    >
                    <!-- <van-button class="dialog-wrapper-btn-item button" @click="handleConfirm">{{ rightBtnText }}</van-button> -->
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Countdown from './countdown.vue';
export default {
    name: "qrCodeDialog",

    components: {
        VueQrcode,
        Countdown
    },

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: "",
        },
        leftBtnText: {
            type: String,
            default: "取消",
        },
        rightBtnText: {
            type: String,
            default: "确定",
        },
    },
    data() {
        return {

        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$refs.countdown.startCountdown();
            } else {
                this.$refs.countdown.resetCountdown();
            }
        }
    },

    methods: {
        end() {
            this.$router.back()
            this.$toast({
                message: '请查看支付情况',
                duration: 3000

            })
        },
        handleShowDialog() {
            this.$emit("update:show");
        },
        hideDialog() {
            this.$emit("update:show", false);
        },
        handleLeftBtn() {
            this.$emit("handleLeftBtn");
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
    },
};
</script>

<style lang="less" scoped>
.dialog {
    z-index: 2100;
    .button {
        color: #fff;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
    .dialog-wrapper {
        width: 650px;
        height: 750px;
        text-align: center;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        .dialog-content {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #212121;
            line-height: 36px;
            text-align: center;
            margin: 40px 0 0 0;
        }
        .dialog-wrapper-btn {
            width: 100%;
            padding: 0 32px;
            .dialog-wrapper-btn-item {
                width: 100%;
                height: 70px;
                border-radius: 16px;
                font-size: 32px;
            }
        }
    }
}
</style>
